import { Component } from '@angular/core';
import { ProgressSpinner } from 'primeng/progressspinner';
import { TranslatePipe } from '@ngx-translate/core';
@Component({
  selector: 'chl-loader',
  imports: [ProgressSpinner],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.css',
})
export class SpinnerComponent {}
